import Numpad from './Numpad';
import Leaderboard from './Leaderboard';

export default function GameView({
  players,
  currentPlayerIndex,
  turnNumber,
  currentScore,
  isFarkle,
  gamePhotoUrl,
  gameCode,
  onNumKey,
  onDelete,
  onQuickAdd,
  onBank,
  onFarkle,
  onUndo,
  canUndo,
  onQuit,
  redemption,
  awaitingInheritChoice,
  onChooseInherit,
  onChooseFresh,
}) {
  const currentPlayer = players[currentPlayerIndex];
  if (!currentPlayer) return null;

  const inRedemption = !!redemption;
  const target = redemption?.currentTarget ?? 0;
  const leader = redemption ? players.find(p => p.id === redemption.currentLeaderId) : null;

  return (
    <div id="game-view">
      {gamePhotoUrl && (
        <img className="game-icon-photo" src={gamePhotoUrl} alt="Game selfie" />
      )}
      <main className="game-main">
        <header className="header">
          <div className="player-info">
            <div className="avatar">{currentPlayer.avatar}</div>
            <div className="player-name">{currentPlayer.name}'s Turn</div>
          </div>
        </header>

        {inRedemption && (
          <div className="redemption-banner">
            <div className="redemption-title">Redemption Round</div>
            <div className="redemption-target">
              Beat {target.toLocaleString()}
              {leader && <span className="redemption-leader"> · {leader.name}</span>}
            </div>
          </div>
        )}

        <div className="score-display-area">
          <div className="input-label">
            {inRedemption ? 'Final Score' : 'Turn Score'}
          </div>
          <div className={`score-input ${currentScore === 0 && !isFarkle ? 'empty' : ''} ${isFarkle ? 'farkle-state' : ''}`}>
            {isFarkle ? 'NO DICE!' : currentScore === 0 ? '0' : currentScore.toLocaleString()}
          </div>
        </div>

        {awaitingInheritChoice ? (
          <div className="inherit-choice">
            <div className="inherit-choice-prompt">
              Inherit the passed dice, or start fresh?
            </div>
            <div className="inherit-choice-buttons">
              <button className="btn-inherit" onClick={onChooseInherit}>
                Inherit · {target.toLocaleString()}
              </button>
              <button className="btn-fresh" onClick={onChooseFresh}>
                Start Fresh · 0
              </button>
            </div>
            <div className="inherit-choice-hint">
              You need to beat {target.toLocaleString()} to take the lead.
            </div>
          </div>
        ) : (
          <>
            <div className="quick-adds">
              <button className="btn-quick" onClick={() => onQuickAdd(50)}>+50</button>
              <button className="btn-quick" onClick={() => onQuickAdd(100)}>+100</button>
              <button className="btn-quick" onClick={() => onQuickAdd(500)}>+500</button>
            </div>

            <Numpad
              currentScore={currentScore}
              isFarkle={isFarkle}
              onNumKey={onNumKey}
              onDelete={onDelete}
              onBank={onBank}
              onFarkle={onFarkle}
              bankLabel={inRedemption ? (isFarkle ? 'Turn Over' : `Finalize ${currentScore.toLocaleString()}`) : undefined}
            />
          </>
        )}
      </main>

      <Leaderboard
        players={players}
        currentPlayerIndex={currentPlayerIndex}
        turnNumber={turnNumber}
        gameCode={gameCode}
        onUndo={onUndo}
        canUndo={canUndo}
        onQuit={onQuit}
        redemption={redemption}
      />
    </div>
  );
}
